// Copyright ©️ 2026 eVolve MEP, LLC

import { AppShellProvider } from 'app/Layout/NavBar/useAppShell';
import { GlobalFiltersProvider } from 'components/Mantine/GlobalFilters/useGlobalFilters';
import { TableViewsProvider } from 'helpers/ag-grid/TableViewPanel/useTableViews';
import { WorkOrderLabelsProvider } from 'hooks/typeCacheHooks/useLabels/useWorkOrderLabels';
import { ManufacturersProvider } from 'hooks/typeCacheHooks/useManufacturers';
import { ShipmentStatusesProvider } from 'hooks/typeCacheHooks/useShipmentStatuses';
import { TaskStatusProvider } from 'hooks/typeCacheHooks/useTaskStatuses';
import { UnitOfMeasureProvider } from 'hooks/typeCacheHooks/useUnitOfMeasure';
import { WorkOrderStatusesProvider } from 'hooks/typeCacheHooks/useWorkOrderStatuses';
import { UserProvider } from 'hooks/user/useUser';
import { ShipmentsProvider } from 'modules/Shop/Shipments/ShipmentsPage/useShipments';
import { WorkOrdersProvider } from 'modules/Shop/WorkOrders/WorkOrdersPage/useWorkOrders';

import { Layout } from './Layout/Layout';

export const PrivateWrapper = () => (
  <UserProvider>
    <AppShellProvider>
      <ManufacturersProvider>
        <WorkOrderStatusesProvider>
          <WorkOrderLabelsProvider>
            <ShipmentStatusesProvider>
              <ShipmentsProvider>
                <TaskStatusProvider>
                  <UnitOfMeasureProvider>
                    <GlobalFiltersProvider>
                      <TableViewsProvider>
                        <WorkOrdersProvider>
                          <Layout />
                        </WorkOrdersProvider>
                      </TableViewsProvider>
                    </GlobalFiltersProvider>
                  </UnitOfMeasureProvider>
                </TaskStatusProvider>
              </ShipmentsProvider>
            </ShipmentStatusesProvider>
          </WorkOrderLabelsProvider>
        </WorkOrderStatusesProvider>
      </ManufacturersProvider>
    </AppShellProvider>
  </UserProvider>
);
